import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F0F4FF] to-[#E6F0FF] text-gray-800">
      {/* Geometric background elements */}
      <div className="absolute inset-0 overflow-hidden opacity-20 pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#7000FF] rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#00FFC6] rounded-full filter blur-3xl translate-x-1/2 translate-y-1/2"></div>
      </div>

      {/* Navigation */}
      <nav className="relative z-10 px-6 py-6 flex justify-between items-center">
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="flex items-center"
        >
          <span className="text-2xl font-bold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-[#7000FF] to-[#00FFC6]">
            ABMR Holdings
          </span>
          <span className="ml-2 text-sm uppercase tracking-widest text-gray-600">Family Office</span>
        </motion.div>
        
        <motion.button
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          onClick={() => navigate('/')}
          className="px-5 py-2 rounded-full bg-gradient-to-r from-[#7000FF] to-[#00FFC6] text-white font-medium text-sm hover:shadow-lg hover:shadow-[#7000FF]/20 transition-all"
        >
          Back to Home
        </motion.button>
      </nav>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white rounded-xl shadow-sm p-8 md:p-12"
        >
          <h1 className="text-3xl md:text-4xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-[#7000FF] to-[#00FFC6]">Terms of Service</h1>
          
          <div className="prose max-w-none text-gray-700">
            <p className="mb-4">Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing or using the ABMR Holdings website ("the Service"), you agree to be bound by these Terms of Service ("Terms"). If you disagree with any part of the terms, you may not access the Service.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">2. Description of Service</h2>
            <p>
              ABMR Holdings provides a website with information about our family office, investment approach, and contact information. We may modify or discontinue, temporarily or permanently, the Service (or any part thereof) with or without notice. You agree that ABMR Holdings shall not be liable to you or to any third party for any modification, suspension, or discontinuance of the Service.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">3. Intellectual Property</h2>
            <p>
              The Service and its original content, features, and functionality are and will remain the exclusive property of ABMR Holdings and its licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of ABMR Holdings.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">4. User Conduct</h2>
            <p>You agree not to use the Service:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>In any way that violates any applicable federal, state, local, or international law or regulation.</li>
              <li>To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail," "chain letter," "spam," or any other similar solicitation.</li>
              <li>To impersonate or attempt to impersonate ABMR Holdings, an ABMR Holdings employee, another user, or any other person or entity.</li>
              <li>To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Service, or which, as determined by us, may harm ABMR Holdings or users of the Service or expose them to liability.</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">5. Links to Other Websites</h2>
            <p>
              Our Service may contain links to third-party websites or services that are not owned or controlled by ABMR Holdings. ABMR Holdings has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You further acknowledge and agree that ABMR Holdings shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">6. Limitation of Liability</h2>
            <p>
              In no event shall ABMR Holdings, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental,  special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use, or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence), or any other legal theory, whether or not we have been informed of the possibility of such damage.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">7. Disclaimer</h2>
            <p>
              Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement, or course of performance.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">8. Governing Law</h2>
            <p>
              These Terms shall be governed and construed in accordance with the laws of the United States and the State of Massachusetts, without regard to its conflict of law provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">9. Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">10. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us at contact@abmrholdings.com.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="relative z-10 px-6 py-8 bg-gray-100 border-t border-gray-200">
        <div className="container mx-auto text-center text-gray-500 text-sm">
          <p>© {new Date().getFullYear()} ABMR Holdings Family Office. All rights reserved.</p>
          <div className="mt-4 space-x-4">
            <button onClick={() => navigate('/privacy-policy')} className="text-[#7000FF] hover:text-[#00FFC6] transition-colors">Privacy Policy</button>
            <button onClick={() => navigate('/terms-of-service')} className="text-[#7000FF] hover:text-[#00FFC6] transition-colors">Terms of Service</button>
            <button onClick={() => navigate('/disclaimer')} className="text-[#7000FF] hover:text-[#00FFC6] transition-colors">Disclaimer</button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;
